import { LOGIN_PREFIX } from 'constants';
import useAuth from 'hooks/useAuth';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { useNavigate } from 'react-router-dom';
import FormPIIProfileContactUsPopup from './popup';

const FormPIIProfileContactUsModal = ({ isShow }) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleOnClick = () => {
    navigate(LOGIN_PREFIX);
    closePortalModalName();
  };

  const handleOnClose = () => {
    logout();
    closePortalModalName();
  };

  return (
    <FormPIIProfileContactUsPopup
      isOpen={isShow}
      buttonLabel1={t('button_logout')}
      onClose={handleOnClose}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default FormPIIProfileContactUsModal;
